package game.entity

import game.Game
import game.Room
import kotlin.random.Random

class Bubbles : Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("bubble")
        frame = Random.nextInt(sprite!!.frames.size)
        frameTimer = Random.nextInt(5)
    }
}